import * as React from 'react';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { ReactComponent as FileDownloadOutlinedIcon } from '../../static/icons/download.svg';
import { Box, Menu, MenuItem } from '@mui/material';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import moment from 'moment';
import autoTable from 'jspdf-autotable';

import '../Widget-Download/Widget-Download.css';
import { exportToXLSX } from '../../utils/csv-export';
import { DateTimeFormat } from '../../utils/properties';

type Props = {
	element?: any;
	handleDownload?: any;
	name?: any;
	Wtype?: any;
	duration?: any;
	rowData?: any;
	columns?: any;
	xlsx?: any;
};

export default function WidgetDownload({ element, handleDownload, name, Wtype, duration, rowData, columns, xlsx }: Props) {
	const { useState } = React;
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const downloadImage = (imageData: string, nName: any) => {
		const fakeLink: any = document.createElement('a');
		fakeLink.style = 'display:none;';
		if (Wtype === 'historic') {
			fakeLink.download = nName ? `${nName}(${moment(duration?.fromTime).format(DateTimeFormat)} - ${moment(duration?.toTime).format(DateTimeFormat)}).jpg` : 'widget-image.jpg';
		} else {
			fakeLink.download = nName ? `${nName}(${moment().format(DateTimeFormat)}).jpg` : 'widget-image.jpg';
		}
		fakeLink.href = imageData;
		document.body.appendChild(fakeLink);
		fakeLink.click();
		document.body.removeChild(fakeLink);
		fakeLink.remove();
	};
	const downloadPDF = (imageData: string, width: number, height: number, nName: any) => {
		let N: any = '';
		if (Wtype === 'historic') {
			N = nName ? `${nName}(${moment(duration?.fromTime).format(DateTimeFormat)} - ${moment(duration?.toTime).format(DateTimeFormat)}).pdf` : 'widget-pdf.pdf';
		} else {
			N = nName ? `${nName}(${moment().format(DateTimeFormat)}).pdf` : 'widget-pdf.pdf';
		}
		const pdf = new jsPDF({
			orientation: 'l',
			unit: 'pt',
			format: [width + 24, height + 24]
		});
		pdf.addImage(imageData, 'JPEG', 12, 12, width, height);
		pdf.save(N);
	};

	const downloadXLS = (rowData: any, columns: any, nName: any) => {
		let N: any = '';
		let columnObj: any = {};
		if (xlsx) {
			columns.forEach((column: any) => {
				columnObj[column?.id ? column?.id : column?.key] = column?.label ? column?.label : column?.name;
				// columnObj[column.id] = column.label;
			});
		} else {
			columns.forEach((column: any) => {
				columnObj[column.id ? column.id : column.key] = column.id ? column.id : column.key;
			});
		}
		if (Wtype === 'historic') {
			N = nName ? `${nName}(${moment(duration?.fromTime).format(DateTimeFormat)} - ${moment(duration?.toTime).format(DateTimeFormat)}).xlsx` : 'export';
		} else {
			N = nName ? `${nName}(${moment().format(DateTimeFormat)}).xlsx` : 'export';
		}
		if (xlsx) {
			columnObj = Object.fromEntries(Object.entries(columnObj).filter(([_, value]) => value !== undefined && value !== ''));
		}
		exportToXLSX(columnObj, rowData, N);
	};




	const handleClose = async (type: string = '', name: string = ''): Promise<void> => {
		// Remove focus from any focused element before closing
		if (document.activeElement && document.activeElement instanceof HTMLElement) {
			document.activeElement.blur();
		}

		setAnchorEl(null);
		if (!type) return;
		if (!element?.current) return;

		try {
			if (type === 'PDF') {
				// Debug logging to see what data we have
				console.log('PDF Generation Debug:', {
					hasRowData: !!rowData,
					rowDataLength: rowData?.length,
					hasColumns: !!columns,
					columnsLength: columns?.length,
					elementType: element.current.tagName,
					elementClasses: element.current.className
				});

				// Check if we have valid table data
				if (rowData && columns && Array.isArray(rowData) && rowData.length > 0 && Array.isArray(columns) && columns.length > 0) {
					console.log('Using data-based PDF generation');
					// Table/data grid - use data-based PDF generation
					const headers = columns.map((col: any) => col.headerName || col.field || col.Header || col.accessor || col.name || col.label || col.id || 'Column');

					const columnStyles: any = {};
					headers.forEach((header, index) => {
						if (header.toLowerCase().includes('groups') ||
							header.toLowerCase().includes('skills')) {
							columnStyles[index] = { cellWidth: 300 };
						}
					});
					const pdf = new jsPDF({
						orientation: 'landscape',
						unit: 'pt',
						format: headers.includes("Skills") ? 'a2' : 'a3' //a4
					});

					// Add title
					pdf.setFontSize(16);
					pdf.setFont('helvetica', 'bold');
					const title = name || 'Data Export';
					pdf.text(title, 40, 40);

					// Prepare table data
					// const headers = columns.map((col: any) => col.headerName || col.field || col.Header || col.accessor || col.name || col.label || col.id || 'Column');
					const rows = rowData.map((row: any) =>
						columns.map((col: any) => {
							const field = col.field || col.accessor || col.key || col.id || col.name || col.label;
							const value = field ? row[field] : '';
							return value !== null && value !== undefined ? String(value) !== '[object Object]' ? String(value) : '' : '';
						})
					);

					console.log('Table data prepared:', { headers, rowCount: rows.length });

					// Generate table using autoTable
					autoTable(pdf, {
						head: [headers],
						body: rows,
						startY: 60,
						styles: {
							fontSize: 8,
							cellPadding: 3,
						},
						columnStyles: columnStyles,
						headStyles: {
							fillColor: [66, 139, 202],
							textColor: [255, 255, 255],
							fontStyle: 'bold'
						},
						alternateRowStyles: {
							fillColor: [245, 245, 245]
						},
						margin: { top: 60, right: 40, bottom: 40, left: 40 },
						tableWidth: 'auto',
						showHead: 'everyPage'
					});

					let pdfName: string = '';
					if (Wtype === 'historic') {
						pdfName = name ? `${name}(${moment(duration?.fromTime).format(DateTimeFormat)} - ${moment(duration?.toTime).format(DateTimeFormat)}).pdf` : 'widget-pdf.pdf';
					} else {
						pdfName = name ? `${name}(${moment().format(DateTimeFormat)}).pdf` : 'widget-pdf.pdf';
					}
					pdf.save(pdfName);
				} else {
					console.log('No valid data, attempting to extract from DOM or capture as image');

					// Try to extract data from DOM first
					const extractedData = extractDataFromDOM(element.current);

					if (extractedData && extractedData.rows.length > 0) {
						console.log('Using extracted DOM data for PDF');

						const pdf = new jsPDF({
							orientation: 'landscape',
							unit: 'pt',
							format: 'a4'
						});

						// Add title
						pdf.setFontSize(16);
						pdf.setFont('helvetica', 'bold');
						const title = name || 'Data Export';
						pdf.text(title, 40, 40);

						// Generate table using autoTable
						autoTable(pdf, {
							head: [extractedData.headers],
							body: extractedData.rows,
							startY: 60,
							styles: {
								fontSize: 8,
								cellPadding: 3,
							},
							headStyles: {
								fillColor: [66, 139, 202],
								textColor: [255, 255, 255],
								fontStyle: 'bold'
							},
							alternateRowStyles: {
								fillColor: [245, 245, 245]
							},
							margin: { top: 60, right: 40, bottom: 40, left: 40 },
							tableWidth: 'auto',
							showHead: 'everyPage'
						});

						let pdfName: string = '';
						if (Wtype === 'historic') {
							pdfName = name ? `${name}(${moment(duration?.fromTime).format(DateTimeFormat)} - ${moment(duration?.toTime).format(DateTimeFormat)}).pdf` : 'widget-pdf.pdf';
						} else {
							pdfName = name ? `${name}(${moment().format(DateTimeFormat)}).pdf` : 'widget-pdf.pdf';
						}
						pdf.save(pdfName);
					} else {
						console.log('Using image capture as fallback');
						// Graph/Chart or fallback - use canvas capture
						await captureGraphAsPDF(element.current, name);
					}
				}
			}
			else if (type === 'JPG') {
				const canvas: HTMLCanvasElement = await html2canvas(element.current, {
					useCORS: true,
					allowTaint: true,
					backgroundColor: '#ffffff',
					scale: 2,
					logging: false
				});
				const imgData: string = canvas.toDataURL('image/jpeg', 0.9);
				downloadImage(imgData, name);
			}
			else if (type === 'XLS') {
				downloadXLS(rowData, columns, name);
			}

			handleDownload(type);
		} catch (error: unknown) {
			console.error('Error generating download:', error);
		}
	};

	// Helper function to extract data from DOM tables
	const extractDataFromDOM = (element: HTMLElement): { headers: string[], rows: string[][] } | null => {
		try {
			// Look for tables in the element
			const tables = element.querySelectorAll('table');

			if (tables.length === 0) {
				console.log('No tables found in DOM');
				return null;
			}

			const table = tables[0]; // Use the first table found
			const headers: string[] = [];
			const rows: string[][] = [];

			// Extract headers
			const headerRow = table.querySelector('thead tr') || table.querySelector('tr');
			if (headerRow) {
				const headerCells = headerRow.querySelectorAll('th, td');
				headerCells.forEach(cell => {
					headers.push(cell.textContent?.trim() || '');
				});
			}

			// Extract data rows
			const bodyRows = table.querySelectorAll('tbody tr');
			if (bodyRows.length > 0) {
				// Has tbody
				bodyRows.forEach(row => {
					const cells = row.querySelectorAll('td, th');
					const rowData: string[] = [];
					cells.forEach(cell => {
						rowData.push(cell.textContent?.trim() || '');
					});
					if (rowData.length > 0) {
						rows.push(rowData);
					}
				});
			} else {
				// No tbody, get all rows except first (header)
				const allRows = table.querySelectorAll('tr');
				allRows.forEach((row, index) => {
					if (index === 0 && !table.querySelector('thead')) {
						return; // Skip header row if no thead
					}
					const cells = row.querySelectorAll('td, th');
					const rowData: string[] = [];
					cells.forEach(cell => {
						rowData.push(cell.textContent?.trim() || '');
					});
					if (rowData.length > 0) {
						rows.push(rowData);
					}
				});
			}

			console.log('Extracted from DOM:', { headers, rowCount: rows.length });

			if (headers.length === 0 && rows.length === 0) {
				return null;
			}

			return { headers, rows };
		} catch (error) {
			console.error('Error extracting data from DOM:', error);
			return null;
		}
	};

	// Helper function to capture graphs/charts as PDF
	const captureGraphAsPDF = async (element: HTMLElement, name: string): Promise<void> => {
		try {
			// Wait for any animations to complete
			await new Promise(resolve => setTimeout(resolve, 1000));

			// Capture the graph with high quality settings
			const canvas = await html2canvas(element, {
				useCORS: true,
				allowTaint: true,
				backgroundColor: '#ffffff',
				scale: 2, // Higher resolution
				logging: false,
				windowWidth: element.scrollWidth || element.clientWidth,
				windowHeight: element.scrollHeight || element.clientHeight,
				onclone: (clonedDoc: Document) => {
					// Ensure all SVG and Canvas elements are visible
					const svgElements = clonedDoc.querySelectorAll('svg');
					svgElements.forEach(svg => {
						if (svg instanceof SVGElement) {
							svg.style.overflow = 'visible';
						}
					});

					const canvasElements = clonedDoc.querySelectorAll('canvas');
					canvasElements.forEach(canvas => {
						if (canvas instanceof HTMLCanvasElement) {
							canvas.style.maxWidth = 'none';
							canvas.style.maxHeight = 'none';
						}
					});
				}
			});

			const imgData = canvas.toDataURL('image/jpeg', 0.9);

			// Create PDF with the captured image
			const pdf = new jsPDF({
				orientation: canvas.width > canvas.height ? 'landscape' : 'portrait',
				unit: 'pt',
				format: 'a4'
			});

			const pdfWidth = pdf.internal.pageSize.getWidth();
			const pdfHeight = pdf.internal.pageSize.getHeight();

			// Add title
			pdf.setFontSize(16);
			pdf.setFont('helvetica', 'bold');
			const title = name || 'Chart Export';
			const titleWidth = pdf.getTextWidth(title);
			pdf.text(title, (pdfWidth - titleWidth) / 2, 30);

			// Calculate image dimensions to fit the page
			const margin = 40;
			const availableWidth = pdfWidth - (margin * 2);
			const availableHeight = pdfHeight - 80; // Space for title and margins

			const imgAspectRatio = canvas.width / canvas.height;
			const availableAspectRatio = availableWidth / availableHeight;

			let imgWidth, imgHeight, imgX, imgY;

			if (imgAspectRatio > availableAspectRatio) {
				// Image is wider - fit to width
				imgWidth = availableWidth;
				imgHeight = availableWidth / imgAspectRatio;
				imgX = margin;
				imgY = 50 + (availableHeight - imgHeight) / 2;
			} else {
				// Image is taller - fit to height
				imgHeight = availableHeight;
				imgWidth = availableHeight * imgAspectRatio;
				imgX = margin + (availableWidth - imgWidth) / 2;
				imgY = 50;
			}

			pdf.addImage(imgData, 'JPEG', imgX, imgY, imgWidth, imgHeight);

			// Generate filename
			let pdfName: string = '';
			if (Wtype === 'historic') {
				pdfName = name ? `${name}(${moment(duration?.fromTime).format(DateTimeFormat)} - ${moment(duration?.toTime).format(DateTimeFormat)}).pdf` : 'widget-pdf.pdf';
			} else {
				pdfName = name ? `${name}(${moment().format(DateTimeFormat)}).pdf` : 'widget-pdf.pdf';
			}

			pdf.save(pdfName);
		} catch (error) {
			console.error('Error capturing graph as PDF:', error);
			throw error;
		}
	};

	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	return (
		<>
			<Box onClick={handleMenuOpen} sx={{ display: 'flex', alignItems: 'center' }}>
				<FileDownloadOutlinedIcon fontSize="small" style={{ color: '#536580' }} />
				<KeyboardArrowDownOutlinedIcon style={{ color: '#536580', fontSize: '10px' }} />
			</Box>
			<Menu
				id="download-appbar"
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right'
				}}
				keepMounted
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				open={open}
				onClose={() => handleClose()}
				className="custom-dropdown"
			>
				<MenuItem className="download-item" onClick={() => handleClose('PDF', name)}>
					<img src={`${process.env.PUBLIC_URL}/img/download-pdf-icon.svg`} width="18" alt="Download PDF Icon"></img> as PDF
				</MenuItem>
				<MenuItem className="download-item" onClick={() => handleClose('JPG', name)}>
					<img src={`${process.env.PUBLIC_URL}/img/download-jpg-icon.svg`} width="18" alt="Download JPG Icon"></img> as JPG
				</MenuItem>
				{(xlsx) &&
					<MenuItem className="xls-download-item" onClick={() => handleClose('XLS', name)}>
						<img src={`${process.env.PUBLIC_URL}/icons/table-view.svg`} width="30" alt="Download XLS Icon"></img> as XLS
					</MenuItem>
				}
			</Menu>
		</>
	);
}
